import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';

const config = {
    apiKey: "AIzaSyAJBGp452VNQ-QkrjMrIBbb1Qf7N5MEVXg",
    authDomain: "progressive-2d975.firebaseapp.com",
    databaseURL: "https://progressive-2d975-default-rtdb.firebaseio.com",
    projectId: "progressive-2d975",
    storageBucket: "progressive-2d975.appspot.com",
    messagingSenderId: "109974914368",
    appId: "1:109974914368:web:4b9ab4d33376a4de7ca6a5",
    measurementId: "G-G4S52J42E4"
};

if (!firebase.apps.length) {
    firebase.initializeApp(config);
}

export const auth = firebase.auth();
export const db = firebase.database();
export const provider = new firebase.auth.GoogleAuthProvider();
